module.exports = { id: "touchscreen", url: "/build/app/img/symbols.svg#touchscreen", viewBox: "", toString: function() { return this.url; } };